<template>
  <v-col
    :class="{
      'get-lower': !$vuetify.breakpoint.mdAndUp,
      'pa-0': true,
      fullScreen: true,
      fullScreenMobile: this.$vuetify.breakpoint.mdAndDown
    }"
    cols="12"
  >
    <v-toolbar dense flat>
      <v-toolbar-title>{{ $t("cost-items.cost-items") }}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-col>
      <SearchCostItem></SearchCostItem>
    </v-col>
    <CommonTable
      list-getter="projectAccountingStore/costItemStore/getList"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="cost-items"
      @updated="updateList"
      :loading.sync="loading"
      :static-dispatch-params="{ project_id: this.project_id }"
      :can-add="canAdd"
      create-item-dispatch="projectAccountingStore/costItemStore/create"
      delete-item-dispatch="projectAccountingStore/costItemStore/delete"
    ></CommonTable>
    <Paginator
      page-getter="projectAccountingStore/costItemStore/getPage"
    ></Paginator>
  </v-col>
</template>

<script>
import Paginator from "../../../components/common/tables/Paginator";
import CommonTable from "../../../components/common/tables/CommonTable";
import { rules } from "../../../components/mixins/rules";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
import { projectPermissions } from "../../../components/mixins/projects/projectPermissions";
import SearchCostItem from "../../../components/projects/accounting/cost-items/SearchCostItem";
export default {
  name: "ContractPeriods",
  components: { Paginator, SearchCostItem, CommonTable },
  props: ["project_id"],
  mixins: [rules, projectTitle, projectPermissions],
  data: function() {
    return {
      headers: [
        {
          text: this.$t("cost-items.title"),
          value: "title",
          align: "left"
        },
        {
          text: this.$t("cost-items.date"),
          value: "date"
        },
        {
          text: this.$t("cost-items.amount"),
          value: "amount"
        },
        {
          text: this.$t("cost-items.cost-centre"),
          value: "cost_centre_name",
          sortable: false
        },
        {
          text: this.$t("cost-items.billing-period"),
          value: "billing_period_name",
          sortable: false
        },
        {
          text: this.$t("cost-items.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      actions: [],
      loading: false
    };
  },
  computed: {
    getParams() {
      return `
                ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.date_from}
                ${this.$route.query.date_to}
                ${this.$route.query.title}
                ${this.$route.query.billing_period}
                ${this.$route.query.cost_centre}
                `;
    },
    slots() {
      let rules = this.rules;
      let costCentres = this.costCentres;
      let billingPeriods = this.billingPeriods;
      return [
        {
          name: "date",
          title: "date",
          type: "date",
          dateFormat: "short",
          form: {
            type: "date",
            rules: [rules.requiredForDate],
            visible: true
          }
        },
        {
          name: "title",
          title: "title",
          type: "link",
          to: "cost-item",
          form: {
            type: "text",
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "amount",
          type: "amount",
          title: "amount",
          form: {
            type: "text",
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "cost_centre_name",
          type: "link",
          to: "cost-centre",
          title: "cost-centre",
          linkParams: {
            id: "cost_centre_id"
          },
          form: {
            type: "select",
            name: "cost_centre_id",
            items: costCentres,
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "billing_period_name",
          title: "billing-period",
          form: {
            type: "select",
            name: "billing_period_id",
            items: billingPeriods,
            rules: [rules.required],
            visible: true
          }
        }
      ];
    },
    billingPeriods() {
      return this.$store.getters[
        "projectAccountingStore/billingPeriodStore/getList"
      ].map(i => ({ value: i.id, text: i.name }));
    },
    costCentres() {
      return this.$store.getters[
        "projectAccountingStore/costCentreStore/getList"
      ].map(i => ({ value: i.id, text: i.name }));
    },
    canAdd: {
      get() {
        return this.hasCurrentProjectPermissions("cost_item.create");
      }
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    getArgumentForTitle() {
      return { chain: [this.$t("cost-items.cost-items")] };
    },
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch("projectAccountingStore/costItemStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    formingParams() {
      return {
        project_id: this.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: this.$route.query.orders,
        filters: {
          date: {
            from: this.$route.query.date_from,
            to: this.$route.query.date_to
          },
          title: this.$route.query.title,
          billing_period: this.$route.query.billing_period,
          cost_centre: this.$route.query.cost_centre
        }
      };
    }
  },
  mounted() {
    this.updateList();
    this.$store.dispatch("projectAccountingStore/billingPeriodStore/getList", {
      params: { limit: -1, project_id: this.$route.params.project_id }
    });
    this.$store.dispatch("projectAccountingStore/costCentreStore/getList", {
      params: { limit: -1, project_id: this.$route.params.project_id }
    });
  }
};
</script>

<style scoped>
.fullScreen {
  height: calc(100vh - 48px - 24px);
  display: flex;
  flex-direction: column;
}
.fullScreen::v-deep > * {
  flex: 0 0 auto;
}
.fullScreen::v-deep .common-table-container {
  height: calc(100vh - 295px);
}
.fullScreenMobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
</style>
